import {createAction} from "@reduxjs/toolkit";

export interface PipelineSettlementPageCriteria {
  dttm: number
  companyId?: string
}

export const setPipelineSettlementPageCriteria = createAction<PipelineSettlementPageCriteria>("ui/pipeline-settlement-page/setCriteria");
